// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-content[data-v-1335d45a] {
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.label-content .content[data-v-1335d45a] {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.label-content .content > div[data-v-1335d45a] {
  width: 100%;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/RegionalQuota/LibQuota.vue","webpack://./LibQuota.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ACAF;ADLA;EAOI,WAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;ACCJ;ADdA;EAeM,WAAA;EACA,OAAA;ACEN","sourcesContent":["\n.label-content {\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  .content {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 10px;\n    > div {\n      width: 100%;\n      flex: 1;\n    }\n  }\n}\n",".label-content {\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.label-content .content {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.label-content .content > div {\n  width: 100%;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
